import getInvalidNotHiddenFormFields from '../helpers/getInvalidNotHiddenFormFields'
import { getLoggedInForms } from '../helpers/formHelper'
import { shouldValidateFormForUser } from '../../user/helpers/formHelper'

function isEmpty(obj) {
  return Object.keys(obj).length === 0
}

function validateAllUserForms({ state, output }) {
  let forms = getLoggedInForms(
    state.get('client.addresstypes'),
    state.get('client.helper.admin.user')
  )
  let current = state.get('client.registrating.current')
  let allValid = true
  let section = null
  Object.keys(forms).forEach(form => {
    let currentForm = forms[form]
    if (shouldValidateFormForUser(currentForm)) {
      let fields = getInvalidNotHiddenFormFields(current[currentForm])
      if (!isEmpty(fields)) {
        allValid = false
        if (!section) {
          section = currentForm
        }
        Object.keys(fields).forEach(field => {
          state.merge(`client.registrating.current.${currentForm}.${field}`, {
            isTouched: true
          })
        })
      }
    }
  })
  if (allValid) {
    output.true({ valid: true, section: null })
  } else {
    output.false({ valid: false, section: section })
  }
}
validateAllUserForms.outputs = ['true', 'false']
export default validateAllUserForms



// WEBPACK FOOTER //
// ./src/modules/user/actions/validateAllUserForms.js